module.exports = __webpack_public_path__ + "img/25.f2eb1a43.jpg";